module.exports = __webpack_public_path__ + "img/Proliferation-CRC_10X_WTA.1e8b2dfe.png";